export const photoUrl = (src, width = 1200) => src?.includes('images.unsplash.com/')
  ? `${src.split('?')[0]}?auto=format&fit=crop&w=${width}&q=85` : src;

export default function EditorialImage({ src, mobileSrc, alt = '', eager = false, sizes = '100vw', className = '' }) {
  const responsive = src?.includes('images.unsplash.com/');
  return <picture className={`hlt-photo ${className}`}>
    {mobileSrc && <source media="(max-width: 700px)" srcSet={photoUrl(mobileSrc, 800)} />}
    <img src={photoUrl(src, 1600)}
      srcSet={responsive ? [480, 800, 1200, 1600, 2000].map(w => `${photoUrl(src, w)} ${w}w`).join(', ') : undefined}
      sizes={sizes} alt={alt} loading={eager ? 'eager' : 'lazy'} fetchPriority={eager ? 'high' : undefined}
      decoding="async" />
  </picture>;
}
